import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import UpdatesSection from './components/UpdatesSection';
import AppSection from './components/AppSection';
import CardsSection from './components/CardsSection';
import AboutSection from './components/AboutSection';
import CommentsSection from './components/CommentsSection';
import RankingSection from './components/RankingSection';
import IndexSection from './components/IndexSection';
import ContactSection from './components/ContactSection';
import TopicsSection from './components/TopicsSection';
import MediaSection from './components/MediaSection';
import FeaturesSection from './components/FeaturesSection';
import FaqSection from './components/FaqSection';
import CarouselSection from './components/CarouselSection';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <UpdatesSection />
        <AppSection />
        <CardsSection />
        <AboutSection />
        <CommentsSection />
        <RankingSection />
        <IndexSection />
        <ContactSection />
        <TopicsSection />
        <MediaSection />
        <FeaturesSection />
        <FaqSection />
        <CarouselSection />
      </main>
      <Footer />
    </>
  );
}